import { render } from "./order-search.vue?vue&type=template&id=1490a32b&scoped=true"
import script from "./order-search.vue?vue&type=script&lang=js"
export * from "./order-search.vue?vue&type=script&lang=js"

import "./order-search.vue?vue&type=style&index=0&id=1490a32b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1490a32b"]])

export default __exports__